import { useTranslation } from 'react-i18next'

import {
  QA_NAME_DENSITY_BTN,
  QA_NAME_DENSITY_FULL_CONTENT_BTN,
} from '../../../../constants/qa'
import { TableControlIcon } from '../../TableControlIcon'

import DensityHideIcon from '../../../../icons/table-hide.svg'
import DensityShowIcon from '../../../../icons/table-open.svg'

function TableDensityButton({
  isDense,
  tooltip = 'Table.DensityBtnKey',
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <TableControlIcon
      {...restProps}
      Icon={isDense ? DensityHideIcon : DensityShowIcon}
      qaName={isDense ? QA_NAME_DENSITY_BTN : QA_NAME_DENSITY_FULL_CONTENT_BTN}
      tooltip={t(tooltip)}
    />
  )
}

export default TableDensityButton
